<template>
	<div>
		<o-icon spin icon="circle-notch" class="fa-spin" v-if="loading"></o-icon>
		<div v-else>
			<div class="box-row" v-for="(item, index) in folders" :key="index">
				<div
					class="is-flex is-justify-content-space-between"
					style="margin-bottom: 0; border-bottom: 1px solid #eee">
					<div>
						<span
							class="is-clickable"
							v-if="item.type === 'folder'"
							@click="item._collapse = !item._collapse">
							<o-icon icon="caret-right" v-if="!item._collapse"></o-icon>
							<o-icon icon="caret-down" v-if="item._collapse"></o-icon>
							<span :class="{ selected: selection?.id == item.id }">{{ item.name }}</span>
						</span>
					</div>
					<div>
						<o-button
							class="is-pulled-right"
							size="small"
							variant="success"
							inverted
							:disabled="selection?.id == item.id"
							@click="SelectFolder(item)">
							{{ selection?.id != item.id ? "Select" : "Selected" }}
						</o-button>
					</div>
				</div>
				<div class="ml-5" v-if="item._collapse">
					<box-file-tree
						v-model="selection"
						:folder-id="item.id"
						:path="path + '/' + item.name"
						:options="options"></box-file-tree>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { ref, inject, onMounted, computed, watch } from "vue";

	export default {
		props: {
			modelValue: {
				type: [String, Number, Object],
				default: undefined
			},
			folderId: {
				type: String,
				default: "0"
			},
			path: {
				type: String,
				default: ""
			},
			options: {
				type: Object,
				default: () => {
					return {};
				}
			}
		},
		emits: ["update:modelValue"],
		setup(props, context) {
			const http = inject("$http");
			const moment = inject("$moment");

			const loading = ref(true);
			const items = ref([]);
			const selection = ref(props.modelValue);

			const folders = computed(() => {
				return items.value.filter((x) => x.type === "folder");
			});
			const files = computed(() => {
				return items.value.filter((x) => x.type === "file");
			});

			const queryString = computed(() => {
				let qs = "";
				if (props.options.sort) {
					qs += "&sort=" + props.options.sort;
				}
				if (props.options.direction == 0 || props.options.direction == 1) {
					qs += "&direction=" + props.options.direction;
				}
				if (props.options.limit) {
					qs += "&limit=" + props.options.limit;
				}

				if (qs.length > 0) {
					qs = "?" + qs.substring(1);
				}
				return qs;
			});

			const GetFolder = async () => {
				const cacheKey = "BOYDEN_fldr_" + props.folderId;
				const json = sessionStorage.getItem(cacheKey);
				if (json) {
					const obj = JSON.parse(json);
					if (moment(obj.expiration).toDate() > moment().toDate()) {
						items.value = obj.items;
						loading.value = false;
						return;
					} else {
						sessionStorage.removeItem(cacheKey);
					}
				}

				try {
					const response = await http.get("/api/v2/box/folder/" + props.folderId + queryString.value);
					items.value = response.data.entries;

					sessionStorage.setItem(
						cacheKey,
						JSON.stringify({
							expiration: moment().add(1, "hours").toDate(),
							items: items.value
						})
					);
				} catch (err) {
					console.error(err);
				}
				loading.value = false;
			};

			const SelectFolder = (row) => {
				selection.value = { id: row.id, path: props.path + "/" + row.name };
				context.emit("update:modelValue", selection.value);
			};

			watch(
				() => props.modelValue,
				(n, o) => {
					if (n !== o) {
						selection.value = props.modelValue;
					}
				}
			);

			watch(
				() => selection.value,
				(n, o) => {
					context.emit("update:modelValue", n);
				}
			);

			onMounted(() => {
				GetFolder();
			});

			return {
				loading,
				items,
				selection,
				folders,
				files,
				SelectFolder
			};
		}
	};
</script>
<style lang="scss" scoped>
	@use "@/assets/css/globalVars.scss" as *;

	.box-file {
		& .box-row {
			font-size: 1.25rem;

			& .selected {
				color: $boyden-blue-light;
			}
		}
	}
</style>
